export const VendorsLocale = {
  en: {
    vendor: 'Vendor',
    vendors: 'Vendors',
    'vendor-management-view': 'Vendor Management View',
    'vendor-profile-edit': 'Vendor Profile Edit',
    yes: 'Yes',
    no: 'No',
    'missing-data': 'missing-data',
    'agreement-type': 'Agreement Type',
    'agreement-start-date': 'Agreement Start Date',
    'agreement-duration-months': 'Agreement Duration Months',
    'agreement-end-date': 'Agreement End Date',
    'project-name': 'Project Name',
    'signing-branch': 'Signing Branch',
    'authorized-signatory': 'Authorized Signatory',
    'psi-commission': 'Psi Commission',
    'PSI-commission-slabs': 'PSI Commission Slabs',
    'marketing-budget-allocation': 'Marketing Budget Allocation',
    'agreement-type-is-required': 'Agreement Type Is Required',
    save: 'Save',
    cancel: 'Cancel',
    'edit-agreement-details': 'Edit Agreement Details',
    discard: 'Discard',
    confirm: 'Confirm',
    'delete-agreement-details': 'Delete Agreement Details',
    'add-agreement-details': 'Add Agreement Details ',
    'are-you-sure-you-want-to-delete-delete-agreement-details':
      'Are you sure you want to delete agreement details',
    'budget-amount': 'Budget Amount',
    'agreement-details': 'Agreement Details',
    'audit-and-compliance': 'Audit And Compliance',
    documents: 'Documents',
    'audit-process-complete': 'Audit Process Complete',
    'audit-date': 'Audit Date',
    'audit-remarks': 'Audit Remarks',
    'edit-audit-and-compliance': 'Edit Audit And Compliance',
    'delete-audit-and-compliance': 'Delete Audit And Compliance',
    'are-you-sure-you-want-to-delete-audit-and-compliance':
      'Are you sure you want to delete audit and compliance ?',
    'audit-process-complete-is-required': 'Audit Process Complete is Required',
    'this-link-is-not-valid': 'This link is not valid',
    'vendor-documents': 'Vendor Documents',
    'add-vendor-document': 'Add Vendor Document',
    category: 'Category',
    title: 'Title',
    remarks: 'Remarks',
    'created-date': 'Created Date',
    'created-by': 'Created By',
    'edit-vendor-successfully': 'Поставщик успешно отредактирован',
    'edit-vendor-failed': 'Не удалось отредактировать поставщика',
    'vendor-class': 'Класс поставщика',
    'FILE-VIEW': 'File View',
    'category-is-required': 'Category is Required',
    'please-select-at-least-one-document':
      'Please Select At Least One Document',
    'vendor-document-created-successfully':
      'Vendor Document Created Successfully',
    'vendor-document-create-failed': 'Vendor Document Create Failed',
    'edit-documents': 'Edit Documents',
    'upload-documents': 'Upload Documents',
    'all-data': 'All Data',
    'missing-data': 'Missing Data',
    view: 'View',

    'edit-vendor': 'Edit Vendor',
    'order-by': 'Order By',
    'created-on': 'Created On',
    'last-updated': 'Last Updated',
    'select-filter-by': 'Select Filter By',
    ascending: 'Ascending',
    descending: 'Descending',
    'select-sort-by': 'Select Sort By',
    apply: 'Apply',
    developerId: 'DeveloperId',
    name: 'Name',
    createdByName: 'Created By Name',
    'employee-name': 'Employee Name',
    'job-title': 'Job Title',
    'email-address': 'Email Address',
    'mobile-number': 'Mobile Number',
    'linkedIn-profile': 'LinkedIn Profile',
    'add-vendor-employee': 'Add Vendor Employee',
    'edit-vendor-employee': 'Edit Vendor Employee',
    'delete-vendor-employee': 'Delete Vendor Employee',
    'are-you-sure-you-want-to-delete-vendor-employee':
      'Are you sure you want to delete vendor employee ?',
    employee: 'Employee',
    'linkedIn-link': 'LinkedIn Link',
    'edit-social-media-link': 'Edit Social Media Link',
    'facebook-link': 'Facebook Link',
    'instagram-account-number': 'Instagram Account Number',
    'snapchat-link': 'Snapchat Link',
    'tiktok-link': 'Tiktok Link',
    'youTube-link': 'YouTube Link',
    'x-link': 'X Link',
    X: 'X',
    edit: 'Edit',
    add: 'Add',
    phoneNumber: 'Phone Number',
    'emailAddress-placeholder': 'Enter Email Address',
    'transactions-history': 'Transactions History',
    owner: 'Owner',
    seeker: 'Seeker',
    status: 'Status',
    all: 'All',
    'lead-actions': 'Lead Actions',
    select: 'Select',
    reassign: 'Reassign',
    'close-leads': 'Close Leads',
    UnqualifiedLeads: 'Unqualified Leads',
    clone: 'Clone',
    matches: 'Matches',
    activities: 'Activities',
    'lead-no': 'Lead No',
    'lead-type': 'Lead Type',
    'unit-type': 'Unit Type',
    open: 'Open',
    closed: 'Closed',
    date: 'Date',
    'assigned-to': 'Assigned To',
    referredTo: 'Referred To',
    'reassign-leads': 'Reassign Leads',
    withCopyAllActivites: 'With Copy All Activites',
    'lead-close-notification': 'Lead Close Notification',
    'close-reason': 'Close Reason',
    'Angry-Bird-atomatically-close-all-leads':
      'Angry Bird Atomatically Close All Leads',
    'confirm-message': 'Confirm Message',
    sale: 'Sale',
    lease: 'Lease',
    'sale-units': 'Sale Units',
    'ref-no': 'Ref No',
    property: 'Property',
    'unit-no': 'Unit No',
    bedrooms: 'Bedrooms',
    sold: 'Sold',
    copy: 'Copy',
    'ref-#': 'Ref #',
    for: 'For',
    created: 'Created',
    'lease-units': 'Lease Units',
    'add-new': 'Add New',
    'search-activity': 'Search Activity',
    'agent-name': 'Agent Name',
    Lead: 'Lead',
    'created-time': 'Created Time',
    'created-By-Name': 'Created By Name',
    lead: 'Lead',
    contact: 'Contact',
    MaintenanceContract: 'Maintenance Contract',
    unit: 'Unit',
    Portfolio: 'Portfolio',
    WorkOrder: 'WorkOrder',
    Property: 'Property',
    'related-to-number': 'Related To Number',
    'related-to-name': 'Related To Name',
    'contact-name': 'Contact Name',
    stage: 'Stage',
    'not-contacted': 'Not Contacted',
    'activity-type': 'Activity Type',
    subject: 'Subject',
    'copy-to': 'Copy To',
    comments: 'Comments',
    minutes: 'Minutes',
    hours: 'Hours',
    days: 'Days',
    'lead-unqualified': 'Lead Unqualified',
    'activity-assign-to-is-required': 'Activity Assign To Is Required',
    'activity-type-is-required': 'Activity Type Is Rrequired',
    'related-to-is-required-one-at-least':
      'Related to is Required one at least',
    'activity-date-is-required': 'Activity Date is required',
    'choose-time-after-now': 'Choose time after now',
    'reminder-for-is-required': 'Reminder for is required',
    'time-must-be-greater-than-zero': 'Time must be greater than zero',
    'reminder-template-is-required': 'Reminder template is required',
    'activity-updated-successfully': 'Activity updated successfully',
    'activity-created-successfully': 'Activity created successfully',
    'activity-update-failed': 'activity update failed',
    'activity-create-failed': 'activity create failed',
    'edit-activity': 'Edit Activity',
    'add-new-activity': 'Add New Activity',
    Details: 'Details',
    Attachments: 'Attachments',
    Reminders: 'Reminders',
    Notifications: 'Notifications',
    'activity-assign-to': 'Activity Assign To',
    'activity-date': 'Activity Date',
    'activity-time': 'Activity Time',
    'lead-score': 'Lead Score',
    'lead-rating': 'Lead Rating',
    'lead-qualification': 'Lead Qualification',
    'view-notifications': 'view Notifications',
    reminder: 'reminder',
    'select-reminder-for': 'Select Reminder For',
    'reminder-type': 'reminder Type',
    Template: 'Template',
    'add-activity': 'Add Activity',
    'activity-deleted-successfully': 'Activity deleted successfully',
    'activity-delete-failed': 'Activity delete failed',
    'activity-delete-description': 'Activity delete description',
    'reminder-type-is-required': 'Reminder Type is required',
    'add-activity-reply': 'Add Activity Reply',
    'transaction-type': 'Transaction Type',
    'transaction-date-time-des': 'Transaction Date Time Des',
    tasks: 'Tasks',
    'add-new-task': 'Add New Task',
    taskCategory: 'Task Category',
    expirationDate: 'Expiration Date',
    'Assigned-to': 'Assigned to',
    'onfig-deleted-successfully': 'Config deleted successfully',
    'config-delete-failed': 'Config delete failed',
    'config-delete-description': 'Config delete description',
    'related-to': 'Related To',
    'branch-name': 'Branch Name',
    subCommunity: 'Sub Community',
    subcommunities: 'Sub Communities',
    street: 'Street',
    'building-name': 'Building Name',
    'building-number': 'Building Number',
    'office-number': 'Office Number',
    'map-coordinates': 'Map Coordinates',
    'postal-zip-code': 'Postal Zip Code',
    'po-box': 'PO Box',
    'select-sub-community': 'Select Sub Community',
    'add-branch-location': 'Add Branch Location',
    'edit-branch-location': 'Edit Branch Location',
    country: 'Country',
    city: 'City',
    district: 'District',
    community: 'Community',
    'floor-number': 'Floor Number',
    'reassign-owner-lead': 'Reassign Owner Lead',
    'reassign-seeker-lead': 'Reassign Seeker Lead',
    'contact-type': 'Contact Type',
    'unit-ref-number': 'Unit Ref No',
    'project-overview': 'Project Overview',
    propertyId: 'Property Id',
    'property-name': 'Property',
    'sub-community-name': 'Sub Community',
    'start-date': 'Start date',
    'hand-over-date': 'Hand over date',
    'number-of-agents': 'Number of agents',
    'total-number-of-units': 'Total number of units',
    number_of_sold_units: 'Number of sold units',
    'number-of-remaining-units': 'Number of remaining units',
    'transaction-value': 'Transaction Value',
    ongoing: 'Ongoing',
    'number-of-sold-units': 'Number of sold units',
    'vendor-profile': 'Vendor Profile',
    'agreements-and-compliance': 'Agreements And Compliance',
    'contacts-and-locations': 'Contacts And Locations',
    'social-media-link': 'Social Media Link',
    'staff-id': 'Staff ID',
    mobile: 'Mobile',
    email: 'Email',
    branch: 'Branch',
    'contact-designation': 'Contact Designation',
    'number-of-transacted-units': 'Number of transacted units',
    'specialty-scope': 'Specialty Scope',
    'agents-overview': 'Agents Overview',
    'lead-id': 'Lead ID',
    'lead-name': 'Lead Name',
    'interested-property': 'Interested Property',
    'interested-vendor': 'Interested Vendor',
    'lead-stage': 'Lead Stage',
    'lead-status': 'Lead Status',
    'assigned-agent': 'Assigned Agent',
    unitRef: 'Unit Ref',
    'leads-overview': 'Leads Overview',
    email_address: 'Email Address',
    'add-file': 'Add File',
    'activity-details': 'Activity Details',
    'data-file': 'Data File',
    'vendor-category': 'Vendor Category',
    'missing-data': 'Missing Data',
    'select-vendors-class': 'Select Vendors Class',
    'select-vendor-category': 'Select Vendor Category',
    'select-agreement-status': 'Select Agreement Status',
    'vendor-name': 'Vendor Name',
    'landline-number': 'Landline Number',
    'select-contact-class': 'Select Contact Class',
    'select-contact': 'Select Contact',
    'corporate-contact': 'Corporate Contact',
    CONTACT_ALREADY_ASSOCIAITED_WITH_OTHER_VENDOR:
      'Contact already associated with other vendor',
    'creation-on': 'Creation On',
    'update-on': 'Update On',
    'updated-by': 'Updated By',
    'agreement-status': 'Agreement Status',
    'PSI-key-person': 'PSI Key Person',
    'number-of-offers': 'Number of offers',
    'last-activity-name': 'Last Activity Name',
    'activity-date': 'Activity Date',
    'activity-created-by': 'Activity Created By',
    'agreement-start-date': 'Agreement Start Date',
    'agreement-expiry-date': 'Agreement Expiry Date',
    'sub-community': 'Sub Community',
    'website-url': 'Website URL',
    'add-new-vendor': 'Add New Vendor',
    Archivecontacts: 'Archive Contacts',
    'user-image': 'User Image',
    copy: 'Copy',
    'data-file': 'Data File',
    'add-activity': 'Add Activity',
    'save-search': 'Save Search',
    'select-city': 'Select City',
    'select-user-account-type': 'Select User Account Type',
    'select-type': 'Select Type',
    action: 'Action',
    'seller-type': 'Seller Type',
    'select-seller-type': 'Select Seller Type',
    'update-search': 'Update Search',
    'clear-search': 'Clear Search',
    'add-vendor-faild': 'Add vendor faild',
    'add-vendor': 'Add Vendor',
    'new-vendor': 'New Vendor',
    'landLine-number': 'LandLine Number',
    language: 'Language',
    'already-existing': 'Already Existing',
    'select-contact': 'Select contact',
    'corporate-contact': 'Corporate contact',
    'enter-vendor-name': 'Enter vendor name',
    'please-enter-vaild-name': 'Please enter vaild name',
    'please-enter-not-duplicate-phone-number':
      'Same landLine number contact  is duplicated',
    'select-vendor-language': 'Select vendor language',
    'select-vendor-country': 'Select vendor country',
    'select-vendor-city': 'Select vendor city',
    'new-vendor-name': 'Name',
    'vendor-name-is-required': 'Vendor name is required',
    'landlineNumber-is-required': 'Landline number is required',
    'language-name-is-required': 'Language name is required',
    'country-is-required': 'Country is required',
    'city-is-required': 'City is required',
    'fill-all-required-fields': 'Fill all required fields',
    'fill-fields-with-correct-values': 'Fill fields with correct values',
    'add-vendor-succssfuly': 'Add vendor succssfuly',
    'General Information': 'General Information',
    vendor_name: 'Vendor Name',
    landline_number: 'Landline Number',
    email_address: 'Email Address',
    vendor_class: 'Vendor Class',
    website_url: 'Website URL',
    'Social Media': 'Social Media',
    facebook_link: 'Facebook Link',
    twitter_link: 'Twitter Link',
    instagram_link: 'Instagram Link',
    snapchat_link: 'Snapchat Link',
    'Location Details': 'Location Details',
    building_name: 'Building Name',
    map: 'Map Coordinates',
    street: 'Street',
    address_line_1: 'Address Line 1',
    near_by: 'Near By',
    'advance-search': 'Advance Search',
    'clear-filters ': 'Clear Filters',
    'account-type': 'Account Type',
    'contact-image': 'Contact image',
    merged: 'Merged',
    'created-by': 'Created On',
    'open-file': 'Open File',
    Successarchive: 'Success Archive',
    Archivecontacts: 'Archive Contacts',
    MassageArchiveContacts: 'Are you sure you want to archive this contact?',
    'created-on': 'Created On',
    'last-updated': 'Last Updated',
    'select-filter-by': 'Select Filter By',
    'ascending ': 'Ascending',
    descending: 'Descending',
    'select-sort-by': 'Select Sort By',
    apply: 'Apply',
    'enter-mobile-number': 'Enter Mobile Number',
    'please-enter-vaild-mobile-number': 'Please enter vaild mobile number',
    'select-vendors-class': 'Select Vendors Class',
    'select-vendor-category': 'Select Vendor Category',
    'select-agreement-status': 'Select Agreement Status',
    'select-country': 'Select Country',
    country: 'Country',
    city: 'City',
    'order-by': 'Order By',
    'clear-filters': 'Clear Filters',
    id: 'ID',
    name: 'Name',
    location: 'Location',
    email: 'Email',
    phone: 'Phone',
    mobile: 'Mobile',
    created: 'Created',
    ascending: 'Ascending',
    vendors: 'Vendors',
    'order-by': 'Order By',
    'clear-filters': 'Clear Filters',
    created: 'Created',
    'created-on': 'Created On',
    name: 'Name',
    email: 'Email',
    location: 'Location',
    coutry: 'Country',
    city: 'City',
    'created-by': 'Created By',
    'vendor-class': 'Vendor Class',
    'edit-vendor-successfully': 'Edit Vendor Successfully',
    'edit-vendor-failed': 'Edit Vendor Failed',

    utilities: {
      contactsImportDialog: {
        'import-contacts': 'Import Contacts',
        import: 'Import',
        'contacts-type': 'Contacts Type',
        corporate: 'Corporate',
        individual: 'Individual',
        'please-select-file-first': 'Please Select File First',
        'file-upload-in-progress': 'File Upload In Progress',
        'contact-file-sent-successfully': 'Contact File Sent Successfully',
        'contact-file-sending-failed': 'Contact File Sending Failed',
        download: 'Download',
        cancel: 'Cancel',
      },
      contactsMergeView: {
        merge: 'Merge',
        cancel: 'Cancel',
        'user-image': 'User Image',
        'contact-id': 'Contact ID',
        final: 'Final',
        obsolete: 'Obsolete',
        original: 'Original',
        'contacts-merged-successfully': 'Contacts merged successfully',
        'contacts-merge-notification':
          'You Will Be Notified When Merge Process Is Done',
        'contacts-merged-failed': 'Contacts merged failed',
        'changing-original-contact-failed':
          "Changing Original Contact Failed . Absolete Contacts Can't Have Transactions",
        download: 'Download',
        THERE_IS_TRANSACTION_IN_CONTACT:
          'Faild Merge! There is Transaction on Obsolete Contact',
      },
    },
    contactBulkUpdate: {
      'selected-contacts': 'Selected contacts',
      'you-can-deselect-contact-before-continue':
        'You can deselect contact before continue',
      'save-changes': 'Save changes',
      cancel: 'Cancel',
      search: 'Search',
      id: 'ID: ',
      'search-contacts': 'Search contacts',
      'contact-fields': 'Contact fields',
      'search-fields': 'Search fields',
      'choose-one-of-the-following-fields':
        'Choose one of the following fields',
      'new-values': 'New values',
      'add-new-value-to-the-following-fields':
        'Add new value to the following fields',
      'contacts-updated-successfully': 'Contacts updated successfully',
      'contacts-update-failed': 'Contacts update failed',
      'number-of-contacts-failed': 'Number of contacts failed',
      'number-of-contacts-succeeded': 'Number of contacts succeeded',
      'update-failed-contacts': 'Update failed contacts',
      'contacts-bulk-update': 'Contacts Bulk Update',
    },
    'contact-bulk-update': 'Contact Bulk Update',
    'pull-confirmation': 'Pull Confirmation',
    'confirmation-text': 'Are you sure you want to pull selected contacts?',
    'error-message': 'Something went wrong, please try again',
    'contact-sent-successfully': 'The contact has been sent successfully',
    'opportunity-contact': 'Opportunity Contact',
    'account-type': 'account-type',
    'contact-image': 'contact-image',
    'open-file': 'Open File',
    'landline-number': 'Landline number',
    website: 'Website',
    location: 'Location',
    'update-on-date': 'Update On Date',
    'advance-search': 'Advance Search',
    'clear-filters': 'Clear Filters',
    'agreement-details-created-successfully':
      'Agreement Details Created Successfully',
    'agreement-details-create-failed': 'Agreement Details Create Failed',
    AgreementType: 'Agreement Type',
    'select-users': 'Select Users',
    'select-branches': 'Select Branches',
    'select-properties': 'Select Properties',
    'select-agreement-end-date': 'Select Agreement End Date',
    'enter-agreement-duration-months': 'Enter Agreement Duration Months',
    'select-agreement-start-date': 'Select Agreement Start Date',
    'select-agreement-type': 'Select Agreement Type',
    'select-agreement-status': 'Select Agreement Status',
    'agreement-status': 'Agreement Status',
    marketingBudgetAmount: 'Marketing Budget Amount',
    isMarketingBudgetAllocation: 'Is Marketing Budget Allocation',
    'agreement-details-update-successfully':
      'Agreement Details Update Successfully',
    'agreement-details-update-failed': 'Agreement Details Update Failed',
    'are-you-sure-you-want-to-delete-delete-agreement-details-id':
      'Are You Sure You Want To Delete Agreement Details Id #',
    'delete-agreement-detail-successfully':
      'Delete Agreement Detail Successfully',
    'failed-to-delete-agreement-detail': 'Failed To Delete Agreement Detail',
    'projects-names': 'Projects Names',
    'signing-branches': 'Signing Branches',
    'authorizedes-signatories': 'Authorized Signatures',
    'audit-and-compliance-created-successfully':
      'Audit And Compliance Created Successfully',
    'audit-and-compliance-create-failed': 'Audit And Compliance Create Failed',
    'select-audit-process-complete': 'Select Audit Process Complete',
    'select-audit-date': 'Select Audit Date',
    'enter-audit-remarks': 'Enter Audit Remarks',
    'add-audit-and-compliance': 'Add Audit And Compliance',
    'are-you-sure-to-delete-audit-and-compliance-id':
      'Are You Sure To Delete Audit And Compliance Id',
    'failed-to-get-audit-and-compliance': 'Failed To Get Audit And Compliance',
    'failed-to-delete-audit-and-compliance':
      'Failed To Delete Audit And Compliance',
    'delete-audit-and-compliance-successfully':
      'Delete Audit And Complianc Successfully',
    'audit-and-compliance-update-successfully':
      'Audit And Compliance Update Successfully',
    'edit-adit-and-compliance': 'Edit Audit And Compliance',
    'select-audit-and-compliance': 'Select Audit And Compliance',
    'vendor-documents-created-successfully':
      'Vendor Documents Created Successfully',
    'vendor-documents-create-failed': 'Vendor Documents Create Failed',
    documentName: 'Document Name',
    'file-name': 'File Name',
    'document-title-is-required': ' Document Title Is Required',
    'please-select-document-title': 'Please Select Document Title',
    'please-select-files': 'Please Select Files',
    documentRemarks: 'Document Remarks',
    'vendor-documents-update-successfully':
      'Vendor Documents Update Successfully',
    'enter-linkedin-profile': 'Enter LinkedIn Profile',
    'linked-in-profile': 'Linked In Profile',
    'enter-employee-name': 'Enter Employee Name',
    'employee-name-is-required': 'Employee Name Is Required',
    'vendor-employee-created-successfully':
      'Vendor Employee Created Successfully',
    'vendor-employee-create-failed': 'Vendor Employee Create Failed',
    'enter-job-title': 'Enter Job Title',
    'please-enter-valid-linkedIn-url': 'Please Enter Valid LinkedIn URL',
    emailAddress: 'Email Address',
    'enter-email-address': 'Enter Email Address',
    'vendor-employee-updated-successfully':
      'Vendor Employee Updated Successfully',
    'vendor-employee-update-failed': 'Vendor Employee Update Failed',
    'delete-dveloper-employee': 'Delete Dveloper Employee',
    'are-you-sure-to-delete-vendor-employee-id':
      'Are You Sure To Delete Vendor Employee Id',
    'mobile-numbers': 'Mobile Numbers',
    'email-addresses': 'Email Addresses',
    'branches-location-created-successfully':
      'Branches Location Created Successfully',
    'branches-location-create-failed': 'Branches Location Create Failed',
    'enter-branch-name': 'Enter Branch Name',
    'select-district': 'Select District',
    'select-city': 'Select City',
    'select-country': 'Select Country',
    'branch-name-is-required': 'Branch Name Is Required',
    'failed-to-delete-branches-location': 'Failed To Delete Branches Location',
    'branches-location-deleted-sucessfuully':
      'Branches Location Deleted Sucessfuully',
    'delete-branch-location': 'Delete Branch Location',
    're-you-sure-you-want-to-delete-branch-location':
      'Are you- sure you want to delete branch location',
    'branch-location-updated-successfully':
      'Branch Location Updated Successfully',
    'branch-location-update-failed': 'Branch Location Update Failed',
    'are-you-sure-you-want-to-delete-branch-location':
      'Are you sure you want to delete branch location',
    'failed-to-delete-social-media-logo': 'Failed To Delete Social Media Logo',
    'social-media-logo-deleted-sucessfuully':
      'Social Media Logo Deleted Sucessfuully',
    'delete-social-media-link': 'Delete Social Media Link',
    'are-you-sure-you-want-to-delete-social-media-logo':
      'Are You Sure You Want To Delete Social Media Logo',
    'failed-to-get-social-media-logo': 'Failed To Get Social Media Logo',
    'instagram-link': 'Instagram Link',
    'please-enter-valid-facebook-link-url':
      'Please enter valid facebook link url',
    'please-enter-valid-snapchat-link-url':
      'Please enter valid snapchat link url',
    'please-enter-valid-instagram-link-url':
      'Please Enter Valid Instagram Link Url',
    'please-enter-valid-tikTok-link-url': 'Please enter valid tikTok link url',
    'please-enter-valid-youtube-link-url':
      'Please enter valid youtube link url',
    'please-enter-valid-x-link-url': 'Please enter valid X link url',
    'social-media-logo-created-successfully':
      'Social Media Logo Created Successfully',
    'social-media-logo-create-failed': 'Social Media Logo Create Failed',
    'social-media-logo-updated-successfully':
      'Social Media Logo Updated Successfully',
    'social-media-logo-updated-failed': 'Social Media Logo Updated Failed',
    'audit-and-compliance-update-failed': 'Audit And Compliance Update Failed',
    'audit-date-is-not-valid': 'Audit Date Is not Valid',
    'vendor-employees': 'Vendor Employees',
    'branches-location': 'Branches Locations',
    'commission-details-created-successfully':
      'Commission Details Created Successfully',
    'commission-details-create-failed': 'Commission Details Create Failed',
    'add-commission': 'Add Commission',
    'for-all-projects': 'For All Projects',
    'specific-projects': 'Specific Projects',
    'failed-to-get-commission-details': 'Failed To Get Commission Details',
    'failed-to-delete-commission-details':
      'Failed To Delete Commission Details',
    'delete-commission-details-successfully':
      'Delete Commission Details Successfully',
    'commission-type': 'Commission Type',
    'value-from': 'Value From',
    'value-to': 'Value To',
    commission: 'Commission',
    'payment-terms': 'Payment Terms',
    'commission-projects': 'Commission Projects',
    createdBy: 'Created By',
    createdOn: 'Created On',
    'delete-commission-details': 'Delete Commission Details',
    'are-you-sure-to-delete-commission-details-id':
      'Are You Sure To Delete Commission Details Id',
    'select-commission-type': 'Select Commission Type',
    'enter-value-from': 'Enter value From',
    'enter-value-to': 'Enter Value To',
    'enter-commission': 'Enter Commission',
    'enter-payment-terms': 'Enter Payment Terms',
    'commission-type-is-required': 'Commission Type Is Required',
    'edit-commission-details': 'Edit Commission Details',
    'commission-details-updated-successfully':
      'Commission Details Updated Successfully',
    'commission-details-update-failed': 'Commission Details Update Failed',
    ForAllProjects: 'For All Projects',
    SpecificProjects: 'Specific Projects',
    'commission-details': 'Commission Details',
    'enter-remarks': 'Enter Remarks',
    commissionDetailId: 'Commission Detail Id',
    'cant-find-result-in-this-location-please-try-select-more-clear-address':
      'Cant find-result in this location please try select more clear address',
    'document-link': 'Document Link',
    'this-contact-vendor-havent-master-vendor-on-any-properties-please-select-properties-and-select-master-vendor-with-this-contact-contact-id':
      "This contact vendor haven't master vendor on any properties please select properties and select master vendor with this contact ID ",
    'please-fill-email-in-correct-way': 'Please fill email in correct way',
    'launch-date': 'Launch Date',
    contactId: 'Contact Id',
    'vendor-name': 'Vendor Name',
    'please-enter-vaild-landline-number': 'Please enter vaild landline number',
      "enter-contact-number": "Enter contact number",
      "contact-number": "Contact Number",
      "please-enter-vaild-contact-number": "Please enter vaild contact number",
      "contact-number-is-required": "Contact number is required" ,
    'please-fill-website-in-correct-way': 'Please fill website in correct way',
    'select-vendor-class': 'Select vendor class',
    'select-authorizedes-signatories': 'Select authorized signatures',
    'enter-landlines-number': 'Enter landline number',
    normal: 'Normal',
    vip: 'VIP',
    vvip: 'VVIP',
    'enter-property-id': 'Enter property id',
    'enter-sub-community': 'Enter sub community',
    'handover-date': 'Handover Date',
    'enter-agent-name': 'Enter agent name',
    'enter-staffId': 'Enter staff ID',
    'enter-mobile-number': 'Enter mobile number',
    'please-enter-vaild-mobile-number': 'Please enter vaild mobile number',
    'assigned-agent-name': 'Assigned agent name',
    'enter-lead-id': 'Enter lead ID',
    'enter-contact-id': 'Enter contact ID',
    'enter-unit-ref-no': 'Enter unit ref no',
    'apply-filters': 'Apply Filters',
    'lead-campaign-name': 'Lead Campaign Name',
    'select-lead-class': 'Select lead class',
    Seller: 'Seller',
    Landlord: 'Landlord',
    Buyer: 'Buyer',
    Tenant: 'Tenant',
    seller: 'Seller',
    landlord: 'Landlord',
    buyer: 'Buyer',
    tenant: 'Tenant',
    'lead-class': 'Lead Class',
    'same-contact-info-is-duplicated-with-contact':
      'Same contact info is duplicated with contact',
    CONTACT_ALREADY_ASSOCIAITED_WITH_OTHER_DEVELOPER:
      'CONTACT ALREADY ASSOCIAITE WITH OTHER DEVELOPER',

    'has-agreement': 'Has Agreement',
    agreementDocument: 'Agreement Document',
    'download-report': 'Download Report',
    'file-in-process':
      'The File in Process When Job Done, We Will Send Notification in Menu for You',
    'server-request-error': 'Problem requesting service from the server',
    psi_commission: 'PSI Commission',
    commission: 'Commission',
    fill_agreement_start_date_and_end_date:
      'Please fill agreement start and end date',
    agreement_updated_successfully: 'Agreement updated successfully',
    agreement_created_successfully: 'Agreement created successfully',
    something_went_wrong: 'Something went wrong, please try again',
    vendor_documents: 'Vendor Documents',
    add_vendor_document: 'Add Vendor Document',
    'vendors-profile': 'Vendors Profile',
    activity_tracking: 'Activity Tracking',
    activity_type_name: 'Activity Type',
    assigned_to: 'Assigned To',
    category_name: 'Category',
    comments: 'Comments',
    contact_name: 'Contact Name',
    created_by_name: 'Created By',
    created_on: 'Created On',
    add_activity: 'Add Activity',
    serviceSettingId: 'Service Setting ID',
    vendorId: 'Vendor ID',
    workingHoursFrom: 'Working Hours From',
    workingHoursTo: 'Working Hours To',
    specificAreaCovered: 'Specific Area Covered',
    deliveryService: 'Delivery Service',
    onSiteServiceAvailability: 'On-site Service Availability',
    remoteServiceAvailability: 'Remote Service Availability',
    daysOfOperation: 'Days of Operation',
    citiesCovered: 'Cities Covered',
    createdBy: 'Created By',
    createdOn: 'Created On',
    working_hours_invalid: "Working hours 'To' should be greater than 'From'",
    settings_updated_successfully: 'Settings updated successfully',
    service_type: 'Service Type',
    service_availability: 'Service Availability',
    service_category: 'Service Category',
    description: 'Description',
    tags: 'Tags',
    service_updated_successfully: 'Service updated successfully',
    service_created_successfully: 'Service created successfully',
    edit_service: 'Edit Service',
    add_service: 'Add Service',
    delete_successfully: 'Deleted successfully',
    delete_failed: 'Delete failed',
    delete_service: 'Delete Service',
    qr_code_helper_text: 'Enter text to encode or upload image',
    setup_settings_first: 'Please set up settings first',
    offer_created_successfully: 'Offer created successfully',
    offer_updated_successfully: 'Offer updated successfully',
    edit_offer: 'Edit Offer',
    add_offer: 'Add Offer',
    offer_name: 'Offer Name',
    service_name: 'Service Name',
    offer_with_duration: 'Offer with Duration',
    start_date: 'Start Date',
    end_date: 'End Date',
    discount: 'Discount',
    psi_commission_included: 'Include PSI commission',
    psi_commission: 'PSI Commission',
    offer_availability: 'Offer Availability',
    promo_code: 'Promo Code',
    qr_code: 'QR Code',
    publish_offer: 'Publish Offer',
    offer_status: 'Offer Status',
    vendor_name: 'Vendor Name',
    category: 'Category',
    service: 'Service',
    published_date: 'Published Date',
    published: 'Published',
    offers: 'Offers',
    exported_successfully:
      'Exported successfully, please check your notifications then alert tab to download requested file',
    no_data_available_for_export: 'No data available for export',
    upload_agreement_document: 'Upload Agreement Document',
    saved_successfully: 'Saved successfully',
    duration: 'Duration',
    created_by: 'Created By',
    created_date: 'Created Date',
    no_agreements: 'No agreement found. Please upload a signed agreement.',
    interested_clients: 'Interested Clients',
    DOCUMENT_NAME_ALREADY_EXISTS: 'Document name already exists',
    CONTACT_ALREADY_ASSOCIATED_WITH_OTHER_VENDOR:
      'Contact is already associated with another vendor',
  },
  ar: {
    psi_commission: 'عمولة PSI',
    commission: 'العمولة',
    fill_agreement_start_date_and_end_date:
      'يرجى تعبئة تاريخ بدء وانتهاء الاتفاقية',
    agreement_updated_successfully: 'تم تحديث الاتفاقية بنجاح',
    agreement_created_successfully: 'تم إنشاء الاتفاقية بنجاح',
    something_went_wrong: 'حدث خطأ ما، يرجى المحاولة مرة أخرى',
    vendor_documents: 'مستندات المورد',
    add_vendor_document: 'إضافة مستند مورد',
    'vendors-profile': 'ملف الموردين',
    activity_tracking: 'تتبع النشاط',
    activity_type_name: 'نوع النشاط',
    assigned_to: 'تم التعيين إلى',
    category_name: 'الفئة',
    comments: 'التعليقات',
    contact_name: 'اسم جهة الاتصال',
    created_by_name: 'تم الإنشاء بواسطة',
    created_on: 'تاريخ الإنشاء',
    add_activity: 'إضافة نشاط',
    serviceSettingId: 'معرف إعداد الخدمة',
    vendorId: 'معرف البائع',
    workingHoursFrom: 'ساعات العمل من',
    workingHoursTo: 'ساعات العمل إلى',
    specificAreaCovered: 'منطقة محددة مغطاة',
    deliveryService: 'خدمة التوصيل',
    onSiteServiceAvailability: 'توفر الخدمة في الموقع',
    remoteServiceAvailability: 'توفر الخدمة عن بُعد',
    daysOfOperation: 'أيام التشغيل',
    citiesCovered: 'المدن المغطاة',
    createdBy: 'أنشئ بواسطة',
    createdOn: 'تاريخ الإنشاء',
    working_hours_invalid: 'يجب أن تكون ساعة الانتهاء أكبر من ساعة البدء',
    settings_updated_successfully: 'تم تحديث الإعدادات بنجاح',
    service_type: 'نوع الخدمة',
    service_availability: 'توفر الخدمة',
    service_category: 'فئة الخدمة',
    description: 'الوصف',
    tags: 'العلامات',
    service_updated_successfully: 'تم تحديث الخدمة بنجاح',
    service_created_successfully: 'تم إنشاء الخدمة بنجاح',
    edit_service: 'تعديل الخدمة',
    add_service: 'إضافة خدمة',
    delete_successfully: 'تم الحذف بنجاح',
    delete_failed: 'فشل الحذف',
    delete_service: 'حذف الخدمة',
    'data-file': 'ملف البيانات',
    'vendor-category': 'فئة المورد',
    'missing-data': 'بيانات مفقودة',
    'select-vendors-class': 'اختر فئة الموردين',
    'select-vendor-category': 'اختر فئة المورد',
    'select-agreement-status': 'اختر حالة الاتفاقية',
    'vendor-name': 'اسم المورد',
    'landline-number': 'رقم الهاتف الأرضي',
    'select-contact-class': 'اختر فئة جهة الاتصال',
    'select-contact': 'اختر جهة الاتصال',
    'corporate-contact': 'جهة اتصال الشركات',
    'vendor-name': 'اسم المورد',
    CONTACT_ALREADY_ASSOCIAITED_WITH_OTHER_VENDOR:
      'جهة الاتصال مرتبطة بالفعل بمورد آخر',
    'creation-on': 'تاريخ الإنشاء',
     "enter-contact-number": "أدخل رقم الاتصال",
    "contact-number": "رقم الاتصال",
    "please-enter-vaild-contact-number": "يرجى إدخال رقم اتصال صالح" ,
    "contact-number-is-required": "رقم الاتصال مطلوب" ,
    'update-on': 'تاريخ التحديث',
    'updated-by': 'تم التحديث بواسطة',
    'agreement-status': 'حالة الاتفاقية',
    'PSI-key-person': 'الشخص الرئيسي في PSI',
    'number-of-offers': 'عدد العروض',
    'last-activity-name': 'اسم آخر نشاط',
    'activity-date': 'تاريخ النشاط',
    'activity-created-by': 'تم إنشاء النشاط بواسطة',
    'agreement-start-date': 'تاريخ بدء الاتفاقية',
    'agreement-expiry-date': 'تاريخ انتهاء الاتفاقية',
    'sub-community': 'المجتمع الفرعي',
    'website-url': 'رابط الموقع الإلكتروني',
    'add-new-vendor': 'إضافة مورد جديد',
    Archivecontacts: 'أرشفة جهات الاتصال',
    'user-image': 'صورة المستخدم',
    copy: 'نسخ',
    'data-file': 'ملف البيانات',
    'add-activity': 'إضافة نشاط',
    'save-search': 'حفظ البحث',
    'select-city': 'اختر المدينة',
    'select-user-account-type': 'اختر نوع حساب المستخدم',
    'select-type': 'اختر النوع',
    action: 'إجراء',
    'seller-type': 'نوع البائع',
    'select-seller-type': 'اختر نوع البائع',
    'update-search': 'تحديث البحث',
    'clear-search': 'مسح البحث',
    'add-vendor-faild': 'فشل في إضافة المورد',
    'add-vendor': 'إضافة مورد',
    'new-vendor': 'مورد جديد',
    'landLine-number': 'رقم الهاتف الأرضي',
    language: 'اللغة',
    'already-existing': 'موجود مسبقًا',
    'select-contact': 'اختر جهة الاتصال',
    'corporate-contact': 'جهة الاتصال المؤسسية',
    'enter-vendor-name': 'أدخل اسم المورد',
    'please-enter-vaild-name': 'يرجى إدخال اسم صالح',
    'please-enter-not-duplicate-phone-number':
      'تم تكرار جهة اتصال بنفس رقم الهاتف الأرضي',
    'select-vendor-language': 'اختر لغة المورد',
    'select-vendor-country': 'اختر دولة المورد',
    'select-vendor-city': 'اختر مدينة المورد',
    'new-vendor-name': 'الاسم',
    'vendor-name-is-required': 'اسم المورد مطلوب',
    'landlineNumber-is-required': 'رقم الهاتف الأرضي مطلوب',
    'language-name-is-required': 'اسم اللغة مطلوب',
    'country-is-required': 'الدولة مطلوبة',
    'city-is-required': 'المدينة مطلوبة',
    'fill-all-required-fields': 'املأ جميع الحقول المطلوبة',
    'fill-fields-with-correct-values': 'املأ الحقول بقيم صحيحة',
    'add-vendor-succssfuly': 'تمت إضافة المورد بنجاح',
    'General Information': 'معلومات عامة',
    vendor_name: 'اسم المورد',
    landline_number: 'رقم الهاتف الأرضي',
    email_address: 'عنوان البريد الإلكتروني',
    vendor_class: 'فئة المورد',
    website_url: 'رابط الموقع',
    'Social Media': 'وسائل التواصل الاجتماعي',
    facebook_link: 'رابط فيسبوك',
    twitter_link: 'رابط تويتر',
    instagram_link: 'رابط انستجرام',
    snapchat_link: 'رابط سناب شات',
    'Location Details': 'تفاصيل الموقع',
    building_name: 'اسم المبنى',
    map: 'إحداثيات الخريطة',
    street: 'الشارع',
    address_line_1: 'السطر الأول من العنوان',
    near_by: 'بالقرب من',
    'advance-search': 'بحث متقدم',
    'clear-filters ': 'مسح الفلاتر',
    'account-type': 'نوع الحساب',
    'contact-image': 'صورة جهة الاتصال',
    merged: 'تم الدمج',
    'created-by': 'تم الإنشاء بواسطة',
    'edit-vendor-successfully': 'تم تعديل المورد بنجاح',
    'edit-vendor-failed': 'فشل في تعديل المورد',
    'vendor-class': 'فئة المورد',
    'open-file': 'فتح الملف',
    Successarchive: 'تمت الأرشفة بنجاح',
    Archivecontacts: 'أرشفة جهات الاتصال',
    MassageArchiveContacts: 'هل أنت متأكد أنك تريد أرشفة جهة الاتصال هذه؟',
    'created-on': 'تاريخ الإنشاء',
    'last-updated': 'آخر تحديث',
    'select-filter-by': 'اختر عامل التصفية حسب',
    'ascending ': 'تصاعدي',
    descending: 'تنازلي',
    'select-sort-by': 'اختر الترتيب حسب',
    apply: 'تطبيق',
    'enter-mobile-number': 'أدخل رقم الجوال',
    'please-enter-vaild-mobile-number': 'يرجى إدخال رقم جوال صحيح',
    'select-vendors-class': 'اختر فئة الموردين',
    'select-vendor-category': 'اختر فئة المورد',
    'select-agreement-status': 'اختر حالة الاتفاقية',
    'select-country': 'اختر الدولة',
    country: 'الدولة',
    city: 'المدينة',
    'order-by': 'الترتيب حسب',
    'clear-filters': 'مسح عوامل التصفية',
    id: 'المعرف',
    name: 'الاسم',
    location: 'الموقع',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    mobile: 'الجوال',
    created: 'تم الإنشاء',
    created: 'تم الإنشاء',
    ascending: 'تصاعدي',
    vendors: 'الموردون',
    'order-by': 'ترتيب حسب',
    'clear-filters': 'مسح الفلاتر',
    'created-on': 'تاريخ الإنشاء',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    location: 'الموقع',
    coutry: 'الدولة',
    city: 'المدينة',
    qr_code_helper_text: 'أدخل نصًا للترميز أو حمّل صورة',
    setup_settings_first: 'يرجى إعداد الإعدادات أولاً',
    offer_created_successfully: 'تم إنشاء العرض بنجاح',
    offer_updated_successfully: 'تم تحديث العرض بنجاح',
    edit_offer: 'تعديل العرض',
    add_offer: 'إضافة عرض',
    offer_name: 'اسم العرض',
    service_name: 'اسم الخدمة',
    offer_with_duration: 'عرض مع مدة',
    start_date: 'تاريخ البدء',
    end_date: 'تاريخ الانتهاء',
    discount: 'الخصم',
    psi_commission_included: 'تضمين عمولة PSI',
    psi_commission: 'عمولة PSI',
    offer_availability: 'توفر العرض',
    promo_code: 'رمز ترويجي',
    qr_code: 'رمز الاستجابة السريعة',
    publish_offer: 'نشر العرض',
    offer_status: 'حالة العرض',
    vendor_name: 'اسم البائع',
    category: 'الفئة',
    service: 'الخدمة',
    published_date: 'تاريخ النشر',
    published: 'تم النشر',
    offers: 'العروض',
    exported_successfully:
      'تم التصدير بنجاح، يرجى التحقق من الإشعارات ثم علامة تبويب التنبيهات لتحميل الملف المطلوب',
    no_data_available_for_export: 'لا توجد بيانات متاحة للتصدير',
    upload_agreement_document: 'تحميل مستند الاتفاقية',
    saved_successfully: 'تم الحفظ بنجاح',
    duration: 'المدة',
    created_by: 'أنشئ بواسطة',
    created_date: 'تاريخ الإنشاء',
    no_agreements: 'لم يتم العثور على أي اتفاقية. يرجى تحميل اتفاقية موقعة.',
    interested_clients: 'العملاء المهتمون',
    DOCUMENT_NAME_ALREADY_EXISTS: 'اسم المستند موجود بالفعل',
    CONTACT_ALREADY_ASSOCIATED_WITH_OTHER_VENDOR:
      'جهة الاتصال مرتبطة بالفعل ببائع آخر',
  },
  ru: {
    psi_commission: 'Комиссия PSI',
    commission: 'Комиссия',
    fill_agreement_start_date_and_end_date:
      'Пожалуйста, укажите дату начала и окончания соглашения',
    agreement_updated_successfully: 'Соглашение успешно обновлено',
    agreement_created_successfully: 'Соглашение успешно создано',
    something_went_wrong: 'Что-то пошло не так, пожалуйста, попробуйте снова',
    vendor_documents: 'Документы поставщика',
    add_vendor_document: 'Добавить документ поставщика',
    'vendors-profile': 'Профиль поставщиков',
    activity_tracking: 'Отслеживание активности',
    activity_type_name: 'Тип активности',
    assigned_to: 'Назначено',
    category_name: 'Категория',
    comments: 'Комментарии',
    contact_name: 'Имя контакта',
    created_by_name: 'Создано',
    created_on: 'Дата создания',
    add_activity: 'Добавить активность',
    serviceSettingId: 'ID настройки услуги',
    vendorId: 'ID поставщика',
    workingHoursFrom: 'Рабочее время с',
    workingHoursTo: 'Рабочее время до',
    specificAreaCovered: 'Охваченная конкретная область',
    deliveryService: 'Служба доставки',
    onSiteServiceAvailability: 'Доступность услуг на месте',
    remoteServiceAvailability: 'Доступность удаленных услуг',
    daysOfOperation: 'Дни работы',
    citiesCovered: 'Покрываемые города',
    createdBy: 'Создано',
    createdOn: 'Создано в',
    working_hours_invalid: "'До' рабочего времени должно быть больше, чем 'С'",
    settings_updated_successfully: 'Настройки успешно обновлены',
    service_type: 'Тип услуги',
    service_availability: 'Доступность услуги',
    service_category: 'Категория услуги',
    description: 'Описание',
    tags: 'Теги',
    service_updated_successfully: 'Услуга успешно обновлена',
    service_created_successfully: 'Услуга успешно создана',
    edit_service: 'Редактировать услугу',
    add_service: 'Добавить услугу',
    delete_successfully: 'Удалено успешно',
    delete_failed: 'Не удалось удалить',
    delete_service: 'Удалить услугу',
    'data-file': 'Файл данных',
    'vendor-category': 'Категория поставщика',
    'missing-data': 'Отсутствующие данные',
    'select-vendors-class': 'Выберите класс поставщиков',
    'select-vendor-category': 'Выберите категорию поставщика',
    'select-agreement-status': 'Выберите статус соглашения',
    'vendor-name': 'Имя поставщика',
    'landline-number': 'Стационарный номер',
    'select-contact-class': 'Выберите класс контакта',
    'select-contact': 'Выберите контакт',
    'corporate-contact': 'Корпоративный контакт',
    'vendor-name': 'Имя поставщика',
    'vendor-name': '供应商名称',
    CONTACT_ALREADY_ASSOCIAITED_WITH_OTHER_VENDOR:
      'Контакт уже связан с другим поставщиком',
    'creation-on': 'Дата создания',
    'update-on': 'Дата обновления',
    'updated-by': 'Обновлено',
    'agreement-status': 'Статус соглашения',
    'PSI-key-person': 'Ключевое лицо PSI',
    'number-of-offers': 'Количество предложений',
    'last-activity-name': 'Название последней активности',
    'activity-date': 'Дата активности',
    'activity-created-by': 'Активность создана',
    'agreement-start-date': 'Дата начала соглашения',
    'agreement-expiry-date': 'Дата окончания соглашения',
    'sub-community': 'Подсообщество',
    'website-url': 'URL веб-сайта',
    'add-new-vendor': 'Добавить нового поставщика',
    Archivecontacts: 'Архивировать контакты',
    'user-image': 'Изображение пользователя',
    copy: 'Копировать',
    'data-file': 'Файл данных',
    'add-activity': 'Добавить активность',
    'save-search': 'Сохранить поиск',
    'select-city': 'Выбрать город',
    'select-user-account-type': 'Выберите тип учетной записи пользователя',
    'select-type': 'Выберите тип',
    action: 'Действие',
    'seller-type': 'Тип продавца',
    'select-seller-type': 'Выберите тип продавца',
    'update-search': 'Обновить поиск',
    'clear-search': 'Очистить поиск',
    'add-vendor-faild': 'Не удалось добавить поставщика',
    'add-vendor': 'Добавить поставщика',
    'new-vendor': 'Новый поставщик',
    'landLine-number': 'Номер стационарного телефона',
    language: 'Язык',
    'already-existing': 'Уже существует',
    'select-contact': 'Выберите контакт',
    'corporate-contact': 'Корпоративный контакт',
    'enter-vendor-name': 'Введите имя поставщика',
    'please-enter-vaild-name': 'Пожалуйста, введите действительное имя',
    'please-enter-not-duplicate-phone-number':
      'Контакт с таким номером уже существует',
    'select-vendor-language': 'Выберите язык поставщика',
    'select-vendor-country': 'Выберите страну поставщика',
    'select-vendor-city': 'Выберите город поставщика',
    'new-vendor-name': 'Имя',
    'vendor-name-is-required': 'Имя поставщика обязательно',
    'landlineNumber-is-required': 'Номер стационарного телефона обязателен',
    'language-name-is-required': 'Язык обязателен',
    'country-is-required': 'Страна обязательна',
    'city-is-required': 'Город обязателен',
    'fill-all-required-fields': 'Заполните все обязательные поля',
    'fill-fields-with-correct-values': 'Заполните поля корректными значениями',
    'add-vendor-succssfuly': 'Поставщик успешно добавлен',
    'General Information': 'Общая информация',
    vendor_name: 'Имя поставщика',
    landline_number: 'Стационарный номер',
    email_address: 'Электронная почта',
    vendor_class: 'Класс поставщика',
    website_url: 'URL веб-сайта',
    'Social Media': 'Социальные сети',
    facebook_link: 'Ссылка на Facebook',
    twitter_link: 'Ссылка на Twitter',
    instagram_link: 'Ссылка на Instagram',
    snapchat_link: 'Ссылка на Snapchat',
    'Location Details': 'Детали местоположения',
    building_name: 'Название здания',
    map: 'Координаты на карте',
    street: 'Улица',
    address_line_1: 'Адресная строка 1',
    near_by: 'Рядом',
    'advance-search': 'Расширенный поиск',
    'clear-filters ': 'Очистить фильтры',
    'account-type': 'Тип учетной записи',
    'contact-image': 'Изображение контакта',
    merged: 'Объединено',
    'created-by': 'Создано',
    'open-file': 'Открыть файл',
    Successarchive: 'Архив успешно',
    Archivecontacts: 'Архивировать контакты',
    MassageArchiveContacts: 'Вы уверены, что хотите архивировать этот контакт?',
    'created-on': 'Создано',
    'last-updated': 'Последнее обновление',
    'select-filter-by': 'Выберите фильтр по',
    'ascending ': 'По возрастанию',
    descending: 'По убыванию',
    'select-sort-by': 'Выберите сортировку по',
    apply: 'Применить',
    'enter-mobile-number': 'Введите номер мобильного телефона',
    'please-enter-vaild-mobile-number':
      'Пожалуйста, введите корректный номер мобильного',
    'select-vendors-class': 'Выберите класс поставщиков',
    'select-vendor-category': 'Выберите категорию поставщика',
    'select-agreement-status': 'Выберите статус соглашения',
    'select-country': 'Выберите страну',
    country: 'Страна',
    city: 'Город',
    'order-by': 'Сортировать по',
    'clear-filters': 'Очистить фильтры',
    id: 'Идентификатор',
    name: 'Имя',
    location: 'Местоположение',
    email: 'Электронная почта',
    phone: 'Телефон',
    mobile: 'Мобильный',
    created: 'Создано',
    country: '国家',
    city: '城市',
    'order-by': '排序方式',
    'clear-filters': '清除筛选项',
    id: '标识符',
 "enter-contact-number": "Введите контактный номер",
  "contact-number": "Контактный номер",
  "please-enter-vaild-contact-number": "Пожалуйста, введите действительный контактный номер" ,
  "contact-number-is-required": "Требуется контактный номер" ,

    name: '名称',
    location: '位置',
    email: '电子邮件',
    phone: '电话',
    mobile: '手机',
    created: '创建时间',
    created: 'Создано',
    ascending: 'По возрастанию',
    vendors: 'Поставщики',
    'order-by': 'Сортировать по',
    'clear-filters': 'Очистить фильтры',
    'created-on': 'Дата создания',
    name: 'Имя',
    email: 'Электронная почта',
    location: 'Местоположение',
    coutry: 'Страна',
    city: 'Город',
    qr_code_helper_text:
      'Введите текст для кодирования или загрузите изображение',
    setup_settings_first: 'Пожалуйста, сначала настройте параметры',
    offer_created_successfully: 'Предложение успешно создано',
    offer_updated_successfully: 'Предложение успешно обновлено',
    edit_offer: 'Редактировать предложение',
    add_offer: 'Добавить предложение',
    offer_name: 'Название предложения',
    service_name: 'Название услуги',
    offer_with_duration: 'Предложение с продолжительностью',
    start_date: 'Дата начала',
    end_date: 'Дата окончания',
    discount: 'Скидка',
    psi_commission_included: 'Включить комиссию PSI',
    psi_commission: 'Комиссия PSI',
    offer_availability: 'Доступность предложения',
    promo_code: 'Промокод',
    qr_code: 'QR-код',
    publish_offer: 'Опубликовать предложение',
    offer_status: 'Статус предложения',
    vendor_name: 'Имя поставщика',
    category: 'Категория',
    service: 'Услуга',
    published_date: 'Дата публикации',
    published: 'Опубликовано',
    offers: 'Предложения',
    exported_successfully:
      'Экспорт завершён успешно, пожалуйста, проверьте уведомления, затем вкладку предупреждений, чтобы загрузить запрошенный файл',
    no_data_available_for_export: 'Нет данных для экспорта',
    upload_agreement_document: 'Загрузить документ соглашения',
    saved_successfully: 'Успешно сохранено',
    duration: 'Продолжительность',
    created_by: 'Создано',
    created_date: 'Дата создания',
    no_agreements:
      'Соглашение не найдено. Пожалуйста, загрузите подписанное соглашение.',
    interested_clients: 'Заинтересованные клиенты',
    DOCUMENT_NAME_ALREADY_EXISTS: 'Имя документа уже существует',
    CONTACT_ALREADY_ASSOCIATED_WITH_OTHER_VENDOR:
      'Контакт уже связан с другим поставщиком',
  },
  cn: {
    psi_commission: 'PSI 佣金',
    commission: '佣金',
    fill_agreement_start_date_and_end_date: '请填写协议的开始和结束日期',
    agreement_updated_successfully: '协议更新成功',
    agreement_created_successfully: '协议创建成功',
    something_went_wrong: '出现错误，请重试',
    vendor_documents: '供应商文件',
    add_vendor_document: '添加供应商文件',
    'vendors-profile': '供应商资料',
    activity_tracking: '活动跟踪',
    activity_type_name: '活动类型',
    assigned_to: '指派给',
    category_name: '类别',
    comments: '评论',
    contact_name: '联系人姓名',
    created_by_name: '创建者',
    created_on: '创建日期',
    add_activity: '添加活动',
    serviceSettingId: '服务设置编号',
    vendorId: '供应商编号',
    workingHoursFrom: '工作时间从',
    workingHoursTo: '工作时间到',
    specificAreaCovered: '覆盖特定区域',
    deliveryService: '送货服务',
    onSiteServiceAvailability: '现场服务可用性',
    remoteServiceAvailability: '远程服务可用性',
    daysOfOperation: '营业日',
    citiesCovered: '覆盖城市',
    createdBy: '创建人',
    createdOn: '创建时间',
    working_hours_invalid: '工作结束时间应大于开始时间',
    settings_updated_successfully: '设置更新成功',
    service_type: '服务类型',
    service_availability: '服务可用性',
    service_category: '服务类别',
    description: '描述',
    tags: '标签',
    service_updated_successfully: '服务更新成功',
    service_created_successfully: '服务创建成功',
    edit_service: '编辑服务',
    add_service: '添加服务',
    delete_successfully: '删除成功',
    delete_failed: '删除失败',
    delete_service: '删除服务',
    'data-file': '数据文件',
    'vendor-category': '供应商类别',
    'missing-data': '缺少数据',
    'select-vendors-class': '选择供应商类别',
    'select-vendor-category': '选择供应商分类',
    'select-agreement-status': '选择协议状态',
    'vendor-name': '供应商名称',
    'landline-number': '固定电话号码',
    'select-contact-class': '选择联系人类别',
    'select-contact': '选择联系人',
    'corporate-contact': '公司联系人',
    CONTACT_ALREADY_ASSOCIAITED_WITH_OTHER_VENDOR: '该联系人已与其他供应商关联',
    'creation-on': '创建时间',
    'update-on': '更新时间',
    'updated-by': '更新者',
    'agreement-status': '协议状态',
    'PSI-key-person': 'PSI 关键人',
    'number-of-offers': '报价数量',
    'last-activity-name': '最近的活动名称',
    'activity-date': '活动日期',
    'activity-created-by': '活动创建者',
    'agreement-start-date': '协议开始日期',
    'agreement-expiry-date': '协议到期日期',
    'sub-community': '子社区',
    'website-url': '网站链接',
    'add-new-vendor': '添加新供应商',
    Archivecontacts: '存档联系人',
    'user-image': '用户图片',
    copy: '复制',
    'data-file': '数据文件',
    'add-activity': '添加活动',
    'save-search': '保存搜索',
    'select-city': '选择城市',
    'select-user-account-type': '选择用户账户类型',
    'select-type': '选择类型',
    action: '操作',
    'seller-type': '卖家类型',
    'select-seller-type': '选择卖家类型',
    'update-search': '更新搜索',
    'clear-search': '清除搜索',
    'add-vendor-faild': '添加供应商失败',
    'add-vendor': '添加供应商',
    'new-vendor': '新供应商',
    'landLine-number': '固定电话',
    language: '语言',
    'already-existing': '已存在',
    'select-contact': '选择联系人',
    'corporate-contact': '公司联系人',
    'enter-vendor-name': '输入供应商名称',
    'please-enter-vaild-name': '请输入有效的名称',
    'please-enter-not-duplicate-phone-number': '重复的固定电话号码联系人',
    'select-vendor-language': '选择供应商语言',
    'select-vendor-country': '选择供应商国家',
    'select-vendor-city': '选择供应商城市',
    'new-vendor-name': '名称',
    'vendor-name-is-required': '供应商名称是必填项',
    'landlineNumber-is-required': '固定电话号码是必填项',
    'language-name-is-required': '语言名称是必填项',
    'country-is-required': '国家是必填项',
    'city-is-required': '城市是必填项',
    'fill-all-required-fields': '请填写所有必填字段',
    'fill-fields-with-correct-values': '请填写正确的值',
    'add-vendor-succssfuly': '供应商添加成功',
    'General Information': '基本信息',
    vendor_name: '供应商名称',
    landline_number: '固定电话',
    email_address: '电子邮件地址',
    vendor_class: '供应商分类',
    website_url: '网站链接',
    'Social Media': '社交媒体',
    facebook_link: 'Facebook 链接',
    twitter_link: 'Twitter 链接',
    instagram_link: 'Instagram 链接',
    snapchat_link: 'Snapchat 链接',
    'Location Details': '位置信息',
    building_name: '建筑名称',
    map: '地图坐标',
    street: '街道',
    address_line_1: '地址行 1',
    near_by: '附近',
    'advance-search': '高级搜索',
    'clear-filters ': '清除筛选',
    'account-type': '账户类型',
    'contact-image': '联系人图片',
    merged: '已合并',
    'created-by': '创建人',
    'edit-vendor-successfully': '供应商编辑成功',
    'edit-vendor-failed': '编辑供应商失败',
    'vendor-class': '供应商类别',
    'open-file': '打开文件',
    Successarchive: '归档成功',
    Archivecontacts: '归档联系人',
    MassageArchiveContacts: '您确定要归档此联系人吗？',
    "contact-number-is-required": "联系号码是必填项" , 
    'created-on': '创建时间',
    'last-updated': '最后更新',
    'select-filter-by': '选择筛选方式',
    'ascending ': '升序',
    descending: '降序',
    'select-sort-by': '选择排序方式',
    apply: '应用',
    'enter-mobile-number': '输入手机号',
    'please-enter-vaild-mobile-number': '请输入有效的手机号',
    'select-vendors-class': '选择供应商分类',
    'select-vendor-category': '选择供应商类别',
    'select-agreement-status': '选择协议状态',
    'select-country': '选择国家',
    created: '已创建',
    ascending: '升序',
    vendors: '供应商',
    'order-by': '排序方式',
    'clear-filters': '清除筛选',
    'created-on': '创建时间',
    name: '名称',
    email: '电子邮件',
    location: '位置',
    coutry: '国家',
    city: '城市',
    qr_code_helper_text: '输入要编码的文本或上传图片',
    setup_settings_first: '请先设置相关设置',
    offer_created_successfully: '优惠创建成功',
    offer_updated_successfully: '优惠更新成功',
    edit_offer: '编辑优惠',
    add_offer: '添加优惠',
    offer_name: '优惠名称',
    service_name: '服务名称',
    offer_with_duration: '有时效的优惠',
    start_date: '开始日期',
    end_date: '结束日期',
    discount: '折扣',
    psi_commission_included: '包含PSI佣金',
    psi_commission: 'PSI佣金',
    offer_availability: '优惠可用性',
    promo_code: '促销代码',
    qr_code: '二维码',
    publish_offer: '发布优惠',
    offer_status: '优惠状态',
    vendor_name: '供应商名称',
    category: '类别',
    service: '服务',
    published_date: '发布时间',
    published: '已发布',
    offers: '优惠',
    exported_successfully:
      '导出成功，请检查您的通知，然后在提醒标签中下载所请求的文件',
    no_data_available_for_export: '没有可导出的数据',
    upload_agreement_document: '上传协议文件',
    saved_successfully: '保存成功',
    duration: '持续时间',
    created_by: '创建者',
    created_date: '创建日期',
    no_agreements: '未找到协议。请上传已签署的协议。',
    interested_clients: '感兴趣的客户',
    DOCUMENT_NAME_ALREADY_EXISTS: '文档名称已存在',
    CONTACT_ALREADY_ASSOCIATED_WITH_OTHER_VENDOR: '联系人已关联至其他供应商',
  },
};

export const VendorsTranslationPath = 'Vendors';
